import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import './index.css'

const DeliveryOption = ({ image, firstLineComponent, secondLineComponent, theme }) => {
  const { firstTextColor, secondTextColor, textSize, fontWeight = 0 } = theme
  return (
    <div className="fs-12">
      <div className="delivery-button__container mb-3">
        <div className="mr-2 delivery-button__container__icon">{image}</div>

        <div className="delivery-button__container__message" style={{ color: firstTextColor, fontSize: textSize }}>
          <div className={`delivery-button__container--first-line ${secondLineComponent ? 'mr-1' : ''}`}>
            {firstLineComponent}
          </div>
          <div
            className={`delivery-button__container__message__second`}
            style={{ color: secondTextColor, fontSize: textSize, fontWeight }}
          >
            {secondLineComponent}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliveryOption

DeliveryOption.defaultProps = {
  image: '',
  firstLineComponent: <Fragment />,
  secondLineComponent: <Fragment />,
  theme: {},
}

DeliveryOption.propTypes = {
  image: PropTypes.string,
  firstLineComponent: PropTypes.object,
  secondLineComponent: PropTypes.object,
  theme: PropTypes.object,
}
